<template>
  <div class="cont">
      <div class="title"></div>
      <div class="box" v-show="type==1">
        <div class="titleA">企业介绍</div>
        <div v-html="html"></div>
        <div class="h-flex">
        <div class="btn2" @click="isShow">编辑</div>
      </div>
      </div>
      <div class="box" v-show="type==2">
        <div id="wangeditor">
        <div ref="editorElem"></div>
      <div class="h-flex">
        <div class="btn1" @click="type=1">取消</div>
        <div class="btn2" @click="entDesc">提交</div>
      </div>
    </div>
      </div>
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import E from "wangeditor"
import base from '../../untils/base'
  export default {
    data() {
      return {
        editor: null,
        html:'',
        type:1
      }
    },
    mounted(){
      // this.createInfo()
      this.getInfoByIdNew()
    },
    methods:{
      isShow(){
        this.type=2
        
        this.createInfo()
      },
      createInfo(){
        this.editor = new E(this.$refs.editorElem);//获取组件并构造编辑器
        this.editor.config.menuTooltipPosition = 'down'
        this.editor.config.menus = [
          'head',  // 标题
          'bold',  // 粗体
          // 'fontSize',  // 字号
          'fontName',  // 字体
          'lineHeight',
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
          'list',  // 列表
          'justify',  // 对齐方式
          'image',  // 插入图片
          'undo',  // 撤销
          'redo'  // 重复
        ]
        this.editor.config.lineHeights = ['1', '1.15', '1.6', '2', '2.5', '3']
        // this.editor.config.fontSizes = {
        //     'x-small': { name: '10px', value: '1' },
        //     'small': { name: '13px', value: '2' },
        //     'normal': { name: '16px', value: '3' },
        //     'large': { name: '18px', value: '4' },
        //     'x-large': { name: '24px', value: '5' },
        //     'xx-large': { name: '32px', value: '6' },
        //     'xxx-large': { name: '48px', value: '7' },
        // }
        this.editor.config.onchange = (html) => {
          this.html = html
        }
        this.editor.config.uploadImgServer = base.url + '/upload/uploadPhoto'
        this.editor.config.uploadFileName = 'file'
        this.editor.config.uploadImgParams = {
            type: 260
        }
        this.editor.config.uploadImgHeaders = {
            accessToken: this.$store.state.token,
        }
        this.editor.config.uploadImgHooks = {
          before: function(xhr, editor, files) {
          // 图片上传之前触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
          // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
          // return {
          // prevent: true,
          // msg: '放弃上传'
          // }
          // console.log("before:",xhr, editor, files)
          },
          success: function(xhr, editor, result) {
          // 图片上传并返回结果，图片插入成功之后触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          console.log("success:",xhr, editor,result)
          },
          fail: function(xhr, editor, result) {
          // 图片上传并返回结果，但图片插入错误时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          console.log("fail:",xhr, editor,result)
          },
          error: function(xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          console.log("error:",xhr, editor)
          },
          // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
          // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
          customInsert: function(insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，参数editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          console.log(insertImg, result,)
          // if(res)
          var url = base.httpCtx+ result.data.saveUrls;
          insertImg(url);
          // result 必须是一个 JSON 格式字符串！！！否则报错
          }
        };
        this.editor.create();

        this.editor.txt.html('<p>' + this.html + '</p>')
      },
      entDesc(){
        myHttp.entDesc({
          id:util.session.get('groupId'),
          entDesc:this.html
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.$message({
              type:'success',
              message:res.data.msg
            })
            this.type=1
          }else{
            this.$message({
              type:'warning',
              message:res.data.msg
            })
          }
        })
      },
      getInfoByIdNew(){
        myHttp.getInfoByIdNew({
          id:util.session.get('groupId'),
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.html= res.data.data.enterprise.entDesc
          }
          
        })
      }
    }
  }
</script>

<style scoped>
*{
  font-size:initial;
}
.cont{
  width: 100%;
  height: 100%;
  padding: 0 24px 10px 8px;
}
.title{
  height: 4vh;
}
.box{
  width: 100%;
  height: 77vh;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
}
::v-deep .w-e-text p{
  text-align: left;
}
.btn1:hover,.btn2:hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn1{
width: 96px;
    height: 41px;
border-radius: 5px;
background: #FFFFFF;
box-sizing: border-box;
border: 1px solid #999999;
font-family: SourceHanSansCN-Normal;
font-size: 16px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
display: flex;
  justify-content: center;
  align-items: center;
}
.btn2{
  margin-left: 30px;
width: 96px;
    height: 41px;
border-radius: 4px;
background: #409EFF;
font-family: SourceHanSansCN-Normal;
font-size: 16px;
font-weight: 350;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
  justify-content: center;
  align-items: center;
}
.h-flex{
  width: 100%;
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.titleA{
  height: 7vh;
  line-height: 7vh;
  text-align: start;
  padding-left:24px;
  font-weight: 600;
    font-size: 23px;
}
::v-deep p{
  text-align: left;
}
::v-deep span{
  text-align: left;
}
</style>